'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Spinner } from '@common/components';
import { SvgCs } from '@common/icon';
import { cn } from '@core/utils';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useInView } from 'react-intersection-observer';
import { AuthInfiniteQueryOptions, UnauthInfiniteQueryOptions } from '@/api';
import { InquiryCard } from '@/app/donation/_components/InquiryCard';
import { INQUIRY_TYPE } from '@/app/donation/constants';
import type { InquiryType } from '@/app/donation/types';
import { DONATION_ROUTES, STORAGE_KEY } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';
import { filledInfiniteQueryOptions } from '@/utils/filledInfiniteQueryOptions';
import { TABS } from '../../../constants';
import { ResponsiveDivider } from '../../GiftDetailTemplate/ResponsiveDivider';
const INITIAL_PAGE = 1;
const INITIAL_SIZE = 20;
interface GiftTabContentInquiryProps {
  productNumber: string;
}
export const GiftTabContentInquiry = t0 => {
  const $ = _c(29);
  const {
    productNumber
  } = t0;
  const isLogin = useAuthStore(_temp);
  const router = useCustomRouter();
  let t1;
  if ($[0] !== isLogin || $[1] !== productNumber) {
    t1 = filledInfiniteQueryOptions(isLogin ? AuthInfiniteQueryOptions["get:/wello/v2/auth/home-inquiry"]({
      query: {
        page: INITIAL_PAGE,
        size: INITIAL_SIZE,
        productNumber
      }
    }) : UnauthInfiniteQueryOptions["get:/wello/v2/allows/home-inquiry"]({
      query: {
        page: INITIAL_PAGE,
        size: INITIAL_SIZE,
        productNumber
      }
    }));
    $[0] = isLogin;
    $[1] = productNumber;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = {
      ...t1
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching
  } = useInfiniteQuery(t2);
  let t3;
  if ($[5] !== fetchNextPage || $[6] !== isFetching) {
    t3 = {
      onChange: inView => {
        if (!isFetching && inView) {
          fetchNextPage();
        }
      }
    };
    $[5] = fetchNextPage;
    $[6] = isFetching;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    ref
  } = useInView(t3);
  const totalCount = data?.pages[0]?.context?.totalCount ?? 0;
  const isDisplayList = totalCount > 0;
  const t4 = !isDisplayList;
  let t5;
  if ($[8] !== t4) {
    t5 = cn("flex flex-col pt-92", "mobile-tablet:pt-52", {
      "pb-60": t4
    });
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className={cn("mb-4 font-700 text-Gray-900 typo-body1", "mobile-tablet:typo-body3")}>상품에 대해 궁금한 것이 있으신가요?</p>;
    t7 = <p className={cn("mb-32 font-400 text-Gray-600 typo-body2", "mobile-tablet:mb-20 mobile-tablet:typo-body4")}>상품 관련 문의는 판매자가 상세히 답변드립니다.</p>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("w-[375px] gap-6", "mobile-tablet:w-200");
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== productNumber || $[14] !== router) {
    t9 = () => {
      sessionStorage.setItem(STORAGE_KEY.IS_DONATION_INQUIRY_BY_GIFT_PRODUCT, "true");
      router.push(DONATION_ROUTES.MY_INQUIRY_POSTING.withSearchParams({
        dynamicPath: {
          type: INQUIRY_TYPE.GIFT_PRODUCT
        },
        searchParams: {
          productNumber,
          redirect: window.location.pathname + window.location.search
        }
      }));
    };
    $[13] = productNumber;
    $[14] = router;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SvgCs className="size-16 text-Gray-600" />;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t9) {
    t11 = <div className="flex w-full flex-col items-center pb-28">{t6}{t7}<Button className={t8} theme="sub-line" dimensions="H48" onClick={t9}>{t10} 답례품 문의하기</Button></div>;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== data?.pages || $[20] !== hasNextPage || $[21] !== isDisplayList || $[22] !== ref || $[23] !== totalCount) {
    t12 = isDisplayList ? <section className="flex flex-col"><ResponsiveDivider /><section className="flex flex-col pt-16"><h2 className="px-20 pb-16 font-700 text-Gray-900 typo-body2">답례품 문의 {totalCount.toLocaleString()}</h2><ul className="flex flex-col">{data?.pages.flatMap(_temp2).map(_temp3)}</ul>{hasNextPage ? <div className="my-30 w-full flex-center" ref={ref}><Spinner /></div> : null}</section></section> : null;
    $[19] = data?.pages;
    $[20] = hasNextPage;
    $[21] = isDisplayList;
    $[22] = ref;
    $[23] = totalCount;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t12 || $[27] !== t5) {
    t13 = <section className={t5} id={TABS.INQUIRY}>{t11}{t12}</section>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t5;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(page) {
  return page.context?.contents ?? [];
}
function _temp3(t0) {
  const {
    homeInquiryId: home_inquiry_id,
    inquiryTypeValue: inquiry_type_value,
    contents,
    createAt: create_at,
    productName: product_name,
    institutionName: institution_name,
    institutionLogoUrl: institution_logo_url,
    answer,
    writerYN: writer_yn,
    optionItems: option_items,
    privateYN: private_yn,
    title,
    fileUrlList: file_url_list,
    mainImageUrl: main_image_url,
    inquiryTypeCd: inquiry_type_cd
  } = t0;
  return <li key={home_inquiry_id}><InquiryCard inquiryType={inquiry_type_value} contents={contents} createAt={create_at} productName={product_name} institutionName={institution_name} institutionLogoUrl={institution_logo_url} answer={answer} writerYN={writer_yn} optionItems={option_items} privateYN={private_yn} title={title} fileUrlList={file_url_list} mainImageUrl={main_image_url} inquiryId={home_inquiry_id} inquiryTypeCd={inquiry_type_cd as InquiryType} className="border-b border-Gray-200" /></li>;
}